module.exports = __webpack_public_path__ + "static/media/photos-maggie-and-dustin-optimized.13df5ba0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/05-why-gatsby/images/photos-maggie-and-dustin-optimized.jpg
// module id = 962
// module chunks = 0